// extracted by mini-css-extract-plugin
export default {"custom-input":"styles_custom-input__TcZSw","custom-button":"styles_custom-button__Ri7KL"};